<template>
    <div class="form-body">
        <AirportSearchSelector
            v-model="oneWay.data.from"
            :label-name="'Departure'"
            :placeholder="'From airport'"
            :error="errors.from"
        />
        <AirportSearchSelector
            v-model="oneWay.data.destination"
            :label-name="'Arrival'"
            :placeholder="'To airport'"
            :error="errors.destination"
        />
        <DatePickerField
            class="one-way-datepicker"
            :labelName="'Departing'"
            :initialDate="oneWay.data.flyDate"
            v-model="oneWay.data.flyDate"
        />
        <SelectField
            :optionsArray="passengersCountOptions"
            :initialValue="oneWay.data.passengersCount"
            v-model="oneWay.data.passengersCount"
            :label-name="'Passengers'"
            :placeholder="'Select a number'"
            :error="errors.passengersCount"
        />
        <SelectField
            :optionsArray="cabinClassesOptions"
            :initialValue="oneWay.data.cabinClass"
            v-model="oneWay.data.cabinClass"
            :label-name="'Cabin class'"
            :placeholder="'Select a class'"
            :error="errors.cabinClass"
        />
        <div class="btn-container">
            <button class="btn" v-on:click="validateForm()">Get Quote</button>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import AirportSearchSelector from './form-fields/AirportsSearchSelector'
import SelectField from './form-fields/select-field'
import DatePickerField from './form-fields/date-picker-field'
import { Validators } from '../use-cases/validators'
import helper from '@/helper.js'

export default {
    name: 'OneWayForm',
    components: {
        AirportSearchSelector,
        DatePickerField,
        SelectField,
    },
    props: ['cabinClassesOptions', 'passengersCountOptions'],
    data() {
        return {
            oneWay: {
                title: 'One way',
                type: 'one_way',
                data: {
                    from: null,
                    destination: null,
                    flyDate: new Date(),
                    passengersCount: null,
                    cabinClass: null,
                },
                suid: null,
            },
            errors: {},
            valid: true,
        }
    },
    created() {
        this.oneWay.data.passengersCount = this.passengersCountOptions.find((o) => o.value === 1)
        this.oneWay.data.cabinClass = this.cabinClassesOptions.find((o) => o.value === 'business')

        // Search unique ID
        this.oneWay.suid = helper.generateUniqueID()
    },
    methods: {
        validateForm() {
            this.errors = {}
            this.valid = true
            Object.keys(this.oneWay.data).map((key) => {
                let validator
                if (key !== 'destination') {
                    validator = Validators.required(this.oneWay.data[key])
                } else {
                    validator = Validators.validateDestination(this.oneWay.data.from, this.oneWay.data[key])
                }
                this.errors[key] = validator.error
                if (this.valid) {
                    this.valid = validator.valid
                }
            })
            if (this.valid) {
                this.submitForm()
            }
        },
        submitForm() {
            const query = {
                type: this.oneWay.type,
                from: this.oneWay.data.from.iata_code,
                to: this.oneWay.data.destination.iata_code,
                flyDate: moment(this.oneWay.data.flyDate.getTime()).format('YYYY-MM-DD'),
                class: this.oneWay.data.cabinClass.value,
                passengers: this.oneWay.data.passengersCount.value,
                suid: this.oneWay.suid,
            }

            // Send Ecommerce Product Click event
            const flyDateString = moment(this.oneWay.data.flyDate.getTime()).format('YYYY.MM.DD')
            this.$gtm.trackEcommerceEvent(
                {
                    click: {
                        actionField: {
                            list: 'search form',
                        },
                        products: [
                            {
                                name: `${query.from}-${query.to} ${query.class.replace(
                                    '_',
                                    ' '
                                )} ${flyDateString}`.toUpperCase(),
                                id: `${query.from}-${query.to}_${query.class}_${flyDateString}`.toLowerCase(),
                                dimension1: query.from.toUpperCase(), // origin
                                dimension2: query.to.toUpperCase(), // destination
                                dimension3: query.class.replace('_', ' ').toLowerCase(), // cabin
                                dimension4: query.type, // trip_type
                                dimension5: `${query.from}-${query.to}`.toUpperCase(), // route
                                metric1: query.passengers, // adult
                                metric2: 0, // child
                                metric3: 0, // infant
                            },
                        ],
                    },
                },
                'Product Clicks',
                false,
                {
                    suid: query.suid,
                }
            )

            helper.yaMetrika.track('reachGoal', 'getaquote')

            this.$router.push({
                path: '/offers',
                query,
            })
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../../../../../assets/scss/global-styles';

* {
    box-sizing: border-box;
}

.form-body {
    padding: 0 15px 20px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    max-width: 750px;

    .btn-container {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;

        .btn {
            margin: 20px auto;
            position: relative;
        }
    }

    .input-block {
        padding: 5px 15px;
        margin: 5px;
        flex-basis: unset;
        width: calc(50% - 10px);

        border: 1px solid #f6f6f9;
        border-radius: 6px;

        >>> .error-message {
            left: 15px;
        }
    }
}

@media (max-width: 768px) {
    .form-body {
        padding: 10px 10px 20px;
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: flex-start;

        .one-way-datepicker {
            &.input-block {
                width: 100%;
            }
        }

        .input-block {
            padding: 10px 10px;
            flex-basis: unset;
            width: calc(50% - 10px);

            .label {
                font-size: 14px;
                line-height: 17px;
            }

            >>> .error-message {
                left: 11px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/shared/forms_entities/OneWayForm.vue